import React, { useState, useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { TextField, Modal } from '@material-ui/core'
import { useStyles } from '../MaterialUiModal'
import ErrorBoundary from '../ErrorBoundary'
import BootstrapAlert from '../element/BootstrapAlert'

const maxTotalFileSize = 7.5 // メガバイトで指定

export default function WfModalApprove (props) {
  const classes = useStyles()
  const declineMode = props.declineMode
  const [modalOpen, setModalOpen] = useState(false)
  const [completed, setCompleted] = useState(false)
  const [isFilesValid, setIsFilesValid] = useState(true)
  const [comment, setComment] = useState('')
  const outerFormRef = useRef(document.getElementById(props.formId))
  const innerFormRef = useRef(null)

  useEffect(() => {
    $('button.open-wf-approve-modal').each((i, el) => {
      $(el).on('click', () => setModalOpen(true))
    })
  }, [])

  useEffect(() => {
    if (outerFormRef.current) {
      if (Array.from(outerFormRef.current.elements).some((elem) => {
        return elem.required && (!elem.value || elem.value === '-1' || elem.value === -1)
      })) {
        setCompleted(false)
      } else {
        setCompleted(true)
      }
    }
  }, [modalOpen])

  function onInputFileChange (e) {
    let totalFileSize = 0
    innerFormRef.current.querySelectorAll('input[type="file"]').forEach((el) => {
      Array.from(el.files).forEach((file) => {
        totalFileSize += file.size
      })
    })
    setIsFilesValid(totalFileSize <= maxTotalFileSize * 1024 * 1024)
  }

  function onSubmitButtonClick () {
    if (outerFormRef.current) {
      Array.from(innerFormRef.current.elements).forEach((element) => {
        const copy = element.cloneNode(true)
        copy.classList.add('d-none')
        outerFormRef.current.insertBefore(copy, null)
      })
      outerFormRef.current.submit()
    }
  }

  return (
    <Modal
      className={classes.modal}
      open={modalOpen}
      onClose={() => setModalOpen(false)}>
      <div className={classes.paper}>
        <form action="" method="post" ref={innerFormRef} encType="multipart/form-data">
          <h2>{declineMode ? '差戻し確認' : '承認確認'}</h2>
          <hr />
          {(!declineMode && !completed)
            ? (
            <BootstrapAlert class="danger">
              <div>
                <div><b>営業入力項目に未入力の項目があるため、承認できません。</b></div>
                <div><b>すべての項目を入力してください。</b></div>
              </div>
            </BootstrapAlert>
              )
            : (
            <>
              {declineMode
                ? (
                <p>
                  申請書を修正してライセンシーに差戻します。<br/>
                  ライセンシーには修正箇所が表示されます。
                </p>
                  )
                : (
                <p>この申請を承認します。</p>
                  )
              }
              <TextField
                variant="standard"
                id='approve_comment'
                name="approve_comment"
                type='text'
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                label='コメント（承認履歴に表示されます）'
                placeholder=""
                multiline={true}
                minRows={3}
                className='w-100 mb-2'
                required={!declineMode && !completed}
                inputProps={{
                  maxLength: 340
                }}
              >
              </TextField>
              <p className="mt-2">ファイルを3つまで添付できます。</p>
              <input type="file" name="file1" onChange={(e) => onInputFileChange(e)} />
              <input type="file" name="file2" onChange={(e) => onInputFileChange(e)} />
              <input type="file" name="file3" onChange={(e) => onInputFileChange(e)} />
              {!isFilesValid && (
                <div className="mt-2">
                  <BootstrapAlert class="danger">
                    <div>
                      添付ファイルはサイズが合計で{maxTotalFileSize}MB以下となるようにしてください。
                    </div>
                  </BootstrapAlert>
                </div>
              )}
              <p className="mt-2">選択したファイルを取り消すには、再度「ファイルの選択」をクリック後、「キャンセル」を選択してください。</p>
            </>
              )
            }
        </form>
        <hr />
        <div className="row">
          <div className="col-6">
            <button type='button' className='btn btn-outline-secondary' onClick={() => setModalOpen(false)}>キャンセル</button>
          </div>
          <div className="col-6 text-right">
            {(declineMode || completed) && (
              <button type='button' className='btn bg-8' onClick={onSubmitButtonClick}
                disabled={!isFilesValid}>
                {declineMode ? '差戻し' : '承認'}
              </button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  )
}

WfModalApprove.propTypes = {
  formId: PropTypes.string,
  declineMode: PropTypes.bool
}

WfModalApprove.defaultProps = {
  declineMode: false
}

$('.wf-modal-approve').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(
    <ErrorBoundary>
      <WfModalApprove {...props}/>
    </ErrorBoundary>,
    el
  )

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
